import styled from 'styled-components';
import { device } from '@/styles/helpers';

export const ScOfferInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const ScOfferYouWon = styled.p`
  margin: 0;
  width: 100%;
  font-family: inherit;
  font-weight: 700;
  font-size: 50px;
  letter-spacing: 1px;
  line-height: 46px;
  text-align: center;
  text-transform: uppercase;
  background: linear-gradient(180deg, #fefefe 0%, #e3d8cf 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;

  @media (${device.mobile}) {
    &.de,
    &.fr-CA,
    &.fr-CH {
      font-size: 42px;
    }
  }
`;

export const ScOfferAmount = styled.p`
  position: relative;
  margin: 0;
  width: 100%;
  text-align: center;
  font-family: "Work Sans";
  font-size: 80px;
  font-style: normal;
  font-weight: 800;
  line-height: 80px; /* 100% */
  letter-spacing: 2.4px;
  text-transform: uppercase;
  background: linear-gradient(
    180deg,
    #fedf79 0%,
    #fcd25d 35.78%,
    #e7a32e 50.63%,
    #cd7e1b 83.42%,
    #f7c54b 108.08%
  );

  &::before {
    content: attr(data-text);
    position: absolute;
    inset: 0;
    z-index: -1;
    color: #a05a05;
    text-shadow: 2px 3px 0 #a05a05;
  }

  &::after {
    content: attr(data-text);
    position: absolute;
    inset: 0;
    z-index: -1;
    -webkit-text-stroke: 3px transparent;
    background: linear-gradient(180deg, #fdf7cf 0%, #ebab36 100%);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
  }

  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
`;

export const ScOfferDivider = styled.div`
  width: 246px;
  max-width: 100%;
  height: 2px;
  background: linear-gradient(
    90deg,
    rgba(254, 221, 116, 0) 0%,
    #e7a32e 22.785%,
    #cd7f1b 49.461%,
    #e7a32e 77.14%,
    rgba(254, 221, 116, 0) 100%
  );
`;
